import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { WidgetsColumnModel } from 'src/app/models/widgets/widgets-column.model';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { CdkDrag, CdkDragDrop } from '@angular/cdk/drag-drop';
import { WidgetsContainerComponentAbstract } from 'src/app/abstract/widgets/widgets-container-component.abstract';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { Logger } from 'src/app/core/logger';
import { CommandService } from 'src/app/services/command/command.service';
import { WidgetsNotifyDeleteService } from 'src/app/services/widgets/widgets-notify-delete.service';
import { WidgetsSelectionService } from 'src/app/services/widgets/widgets-selection.service';
import { WidgetsRelatedinputModel } from 'src/app/models/widgets/widgets-related-input.model';
@Component({
  selector: '[appWidgetsColumn]',
  templateUrl: './widgets-column.component.html',
  styleUrls: ['./widgets-column.component.scss'],
})
export class WidgetsColumnComponent
  extends WidgetsContainerComponentAbstract
  implements OnInit {
  @Input() data: WidgetsColumnModel = new WidgetsColumnModel();
  @Input() dropListIds: string[] = [];
  @Output() dropListIdAdded: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private widgetsService: WidgetsService,
    private selectionService: WidgetsSelectionService,    
    private logger: Logger,
    private commandService: CommandService,
    private notifyDeleteService: WidgetsNotifyDeleteService
  ) {
    super();
  }

  ngOnInit(): void {
    // this.logger.log(this.data);
  }

  onWidgetDroppedToCanvas(
    event: CdkDragDrop<WidgetsAbstract[], WidgetsAbstract[], any>
  ): WidgetsAbstract {
    return this.commandService.execute(this.data, event.item.data);
  }

  isDroppableWidget(item: CdkDrag<WidgetsAbstract>) {
    // Constraints: ROWS, INPUT, HEADERS, ARRAYS AND CUSTOM widgets are allowed under a COLUMN
    switch (item.data.widgetType) {
      case WidgetsTypeEnum.ROW:
      case WidgetsTypeEnum.FIELD:
      case WidgetsTypeEnum.TEXT:
      case WidgetsTypeEnum.RADIO:
      case WidgetsTypeEnum.INPUT:
      case WidgetsTypeEnum.QUESTION:
      case WidgetsTypeEnum.ARRAY:
      case WidgetsTypeEnum.TIME_RANGE:
      case WidgetsTypeEnum.CHECKBOX:
      case WidgetsTypeEnum.ORDINAL_IN_SET:
        return true;
    }

    return false;
  }

  onDeleteModal(): void {
    this.notifyDeleteService.notifyDelete(this.data);
  }

  setWidth(width: number) {
    this.data.width = width;
  }

  clone(WidgetsAbstract: any): WidgetsAbstract {
    throw new Error('Method not implemented.');
  }

  onWidgetsReordered(culprits: WidgetsAbstract[]) {
    // throw new Error('Method not implemented.');
  }

  onSelect($event) {
    this.selectionService.toggleSelection(this.data);
  }    
}
